import PitchTemplatesPage from './pitchTemplatesPage.view';

export default PitchTemplatesPage;
